// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Core__Promise from "@rescript/core/src/Core__Promise.bs.js";
import * as Utils$OrcaPaymentPage from "./Utilities/Utils.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "./Utilities/JotaiAtoms.bs.js";
import * as ApiEndpoint$OrcaPaymentPage from "./Utilities/ApiEndpoint.bs.js";
import * as ErrorOccured$OrcaPaymentPage from "./Components/ErrorOccured.bs.js";
import * as CollectWidget$OrcaPaymentPage from "./CollectWidget.bs.js";
import * as PaymentHelpers$OrcaPaymentPage from "./Utilities/PaymentHelpers.bs.js";
import * as PaymentMethodCollectTypes$OrcaPaymentPage from "./Types/PaymentMethodCollectTypes.bs.js";
import * as PaymentMethodCollectUtils$OrcaPaymentPage from "./Utilities/PaymentMethodCollectUtils.bs.js";

function PaymentMethodCollectElement(props) {
  var logger = props.logger;
  var match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var match$1 = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  var themeObj = match$1.themeObj;
  var keys = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.keys);
  var options = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.paymentMethodCollectOptionAtom);
  var match$2 = React.useState(function () {
        return PaymentMethodCollectUtils$OrcaPaymentPage.defaultAvailablePaymentMethods;
      });
  var setAvailablePaymentMethods = match$2[1];
  var availablePaymentMethods = match$2[0];
  var match$3 = React.useState(function () {
        return PaymentMethodCollectUtils$OrcaPaymentPage.defaultAvailablePaymentMethodTypes;
      });
  var setAvailablePaymentMethodTypes = match$3[1];
  var availablePaymentMethodTypes = match$3[0];
  var match$4 = React.useState(function () {
        return false;
      });
  var setLoader = match$4[1];
  var loader = match$4[0];
  var match$5 = React.useState(function () {
        
      });
  var setSecondsUntilRedirect = match$5[1];
  var secondsUntilRedirect = match$5[0];
  var match$6 = React.useState(function () {
        return false;
      });
  var setShowStatus = match$6[1];
  var showStatus = match$6[0];
  var match$7 = React.useState(function () {
        return PaymentMethodCollectUtils$OrcaPaymentPage.defaultStatusInfo;
      });
  var setStatusInfo = match$7[1];
  var statusInfo = match$7[0];
  React.useEffect((function () {
          var availablePM = [];
          var availablePMT = [];
          options.enabledPaymentMethods.forEach(function (pm) {
                switch (pm.TAG) {
                  case "Card" :
                      if (!availablePM.includes("Card")) {
                        availablePM.push("Card");
                        availablePMT.push({
                              TAG: "Card",
                              _0: "Debit"
                            });
                        return ;
                      } else {
                        return ;
                      }
                  case "BankRedirect" :
                      if (!availablePM.includes("BankRedirect")) {
                        availablePM.push("BankRedirect");
                      }
                      if (!availablePMT.includes(pm)) {
                        availablePMT.push(pm);
                        return ;
                      } else {
                        return ;
                      }
                  case "BankTransfer" :
                      if (!availablePM.includes("BankTransfer")) {
                        availablePM.push("BankTransfer");
                      }
                      if (!availablePMT.includes(pm)) {
                        availablePMT.push(pm);
                        return ;
                      } else {
                        return ;
                      }
                  case "Wallet" :
                      if (!availablePM.includes("Wallet")) {
                        availablePM.push("Wallet");
                      }
                      if (!availablePMT.includes(pm)) {
                        availablePMT.push(pm);
                        return ;
                      } else {
                        return ;
                      }
                  
                }
              });
          setAvailablePaymentMethods(function (param) {
                return availablePM;
              });
          setAvailablePaymentMethodTypes(function (param) {
                return availablePMT;
              });
        }), [options.enabledPaymentMethods]);
  React.useEffect((function () {
          var match = options.returnUrl;
          if (match !== undefined && showStatus) {
            setSecondsUntilRedirect(function (param) {
                  return 5;
                });
            var interval = setInterval((function () {
                    setSecondsUntilRedirect(function (prev) {
                          if (prev !== undefined) {
                            if (prev > 0) {
                              return prev - 1 | 0;
                            } else {
                              return prev;
                            }
                          } else {
                            return 5;
                          }
                        });
                  }), 1000);
            setTimeout((function () {
                    clearInterval(interval);
                    var url = new URL(match);
                    url.searchParams.set("payout_id", options.payoutId);
                    url.searchParams.set("status", PaymentMethodCollectUtils$OrcaPaymentPage.getPayoutStatusString(statusInfo.status));
                    Utils$OrcaPaymentPage.openUrl(url.href);
                  }), 5010);
          }
          
        }), [showStatus]);
  var handleSubmit = function (pmd) {
    setLoader(function (param) {
          return true;
        });
    var flow = options.flow;
    var pmdBody = PaymentMethodCollectUtils$OrcaPaymentPage.formBody(flow, pmd);
    var createPaymentMethodPromiseWrapped = function () {
      return Core__Promise.$$catch(PaymentHelpers$OrcaPaymentPage.createPaymentMethod(Core__Option.getOr(keys.clientSecret, ""), keys.publishableKey, logger, "", ApiEndpoint$OrcaPaymentPage.getApiEndPoint(undefined, undefined), pmdBody).then(function (res) {
                        console.warn("DEBUGG RES", res);
                        return Promise.resolve();
                      }), (function (err) {
                      console.error("DEBUGG ERR", err);
                      return Promise.resolve();
                    })).finally(function () {
                  setLoader(function (param) {
                        return false;
                      });
                });
    };
    var confirmPayoutPromiseWrapper = function () {
      var endpoint = ApiEndpoint$OrcaPaymentPage.getApiEndPoint(undefined, undefined);
      return Core__Promise.$$catch(PaymentHelpers$OrcaPaymentPage.confirmPayout(Core__Option.getOr(keys.clientSecret, ""), keys.publishableKey, logger, "", endpoint, pmdBody, options.payoutId).then(function (res) {
                        var data = PaymentMethodCollectTypes$OrcaPaymentPage.decodePayoutConfirmResponse(res);
                        if (data !== undefined) {
                          if (data.TAG === "SuccessResponse") {
                            var res$1 = data._0;
                            var updatedStatusInfo_status = res$1.status;
                            var updatedStatusInfo_payoutId = res$1.payoutId;
                            var updatedStatusInfo_message = PaymentMethodCollectUtils$OrcaPaymentPage.getPayoutStatusMessage(res$1.status, localeString);
                            var updatedStatusInfo_code = res$1.errorCode;
                            var updatedStatusInfo_errorMessage = res$1.errorMessage;
                            var updatedStatusInfo = {
                              status: updatedStatusInfo_status,
                              payoutId: updatedStatusInfo_payoutId,
                              message: updatedStatusInfo_message,
                              code: updatedStatusInfo_code,
                              errorMessage: updatedStatusInfo_errorMessage,
                              reason: undefined
                            };
                            setStatusInfo(function (param) {
                                  return updatedStatusInfo;
                                });
                          } else {
                            var err = data._0;
                            var updatedStatusInfo_payoutId$1 = options.payoutId;
                            var updatedStatusInfo_message$1 = localeString.payoutStatusFailedMessage;
                            var updatedStatusInfo_code$1 = err.code;
                            var updatedStatusInfo_errorMessage$1 = err.message;
                            var updatedStatusInfo_reason = err.reason;
                            var updatedStatusInfo$1 = {
                              status: "Failed",
                              payoutId: updatedStatusInfo_payoutId$1,
                              message: updatedStatusInfo_message$1,
                              code: updatedStatusInfo_code$1,
                              errorMessage: updatedStatusInfo_errorMessage$1,
                              reason: updatedStatusInfo_reason
                            };
                            setStatusInfo(function (param) {
                                  return updatedStatusInfo$1;
                                });
                          }
                        } else {
                          var updatedStatusInfo_payoutId$2 = options.payoutId;
                          var updatedStatusInfo_message$2 = localeString.payoutStatusFailedMessage;
                          var updatedStatusInfo$2 = {
                            status: "Failed",
                            payoutId: updatedStatusInfo_payoutId$2,
                            message: updatedStatusInfo_message$2,
                            code: undefined,
                            errorMessage: undefined,
                            reason: undefined
                          };
                          setStatusInfo(function (param) {
                                return updatedStatusInfo$2;
                              });
                        }
                        return Promise.resolve();
                      }), (function (err) {
                      console.error("CRITICAL - Payouts confirm failed with unknown error", err);
                      var updatedStatusInfo_payoutId = options.payoutId;
                      var updatedStatusInfo_message = localeString.payoutStatusFailedMessage;
                      var updatedStatusInfo = {
                        status: "Failed",
                        payoutId: updatedStatusInfo_payoutId,
                        message: updatedStatusInfo_message,
                        code: undefined,
                        errorMessage: undefined,
                        reason: undefined
                      };
                      setStatusInfo(function (param) {
                            return updatedStatusInfo;
                          });
                      return Promise.resolve();
                    })).finally(function () {
                  setShowStatus(function (param) {
                        return true;
                      });
                  setLoader(function (param) {
                        return false;
                      });
                });
    };
    if (flow === "PayoutLinkInitiate") {
      Core__Promise.$$catch(confirmPayoutPromiseWrapper().then(function () {
                return Promise.resolve();
              }), (function (param) {
              return Promise.resolve();
            }));
      return ;
    }
    pmdBody.push([
          "customer_id",
          options.customerId
        ]);
    Core__Promise.$$catch(createPaymentMethodPromiseWrapped().then(function () {
              return Promise.resolve();
            }), (function (param) {
            return Promise.resolve();
          }));
  };
  var renderCollectWidget = function () {
    return React.createElement("div", {
                className: "flex flex-row overflow-scroll lg:w-6/10"
              }, React.createElement("div", {
                    className: "relative w-full h-min lg:w-auto lg:mx-12 lg:mt-20 lg-mb-10"
                  }, loader ? React.createElement("div", {
                          className: "absolute h-full w-full bg-jp-gray-600 bg-opacity-80"
                        }) : null, React.createElement(CollectWidget$OrcaPaymentPage.make, {
                        availablePaymentMethods: availablePaymentMethods,
                        availablePaymentMethodTypes: availablePaymentMethodTypes,
                        primaryTheme: options.theme,
                        handleSubmit: handleSubmit,
                        formLayout: options.formLayout
                      })));
  };
  var renderPayoutStatus = function () {
    var status = statusInfo.status;
    var imageSource = PaymentMethodCollectUtils$OrcaPaymentPage.getPayoutImageSource(status);
    var readableStatus = PaymentMethodCollectUtils$OrcaPaymentPage.getPayoutReadableStatus(status, localeString);
    var statusInfoFields = [{
        key: localeString.infoCardRefId,
        value: options.payoutId
      }];
    return React.createElement("div", {
                className: "flex flex-col items-center justify-center self-center leading-none\n        xs:mt-auto xs:mb-auto\n        lg:ml-auto lg:mr-auto",
                style: {
                  color: themeObj.colorText,
                  fontFamily: themeObj.fontFamily,
                  fontSize: themeObj.fontSizeBase
                }
              }, React.createElement("div", {
                    className: "flex flex-col items-center rounded-lg max-w-[500px]\n          xs:shadow-lg"
                  }, React.createElement("div", {
                        className: "flex flex-row justify-between items-center w-full px-10 py-5 border-b border-jp-gray-300"
                      }, React.createElement("div", {
                            className: "text-2xl font-semibold"
                          }, options.collectorName), React.createElement("img", {
                            className: "h-12 w-auto max-w-21",
                            alt: "o",
                            src: options.logo
                          })), React.createElement("img", {
                        className: "h-40 w-40 mt-7",
                        alt: "o",
                        src: imageSource
                      }), React.createElement("div", {
                        className: "text-xl font-semibold mt-2.5"
                      }, readableStatus), React.createElement("div", {
                        className: "text-jp-gray-800 m text-center mx-10 mb-10"
                      }, statusInfo.message), React.createElement("div", {
                        className: "flex border-t border-bg-jp-gray-300 py-5 w-full justify-center"
                      }, React.createElement("div", {
                            className: "flex flex-col max-w-[500px] bg-white w-full mx-2.5\n            xs:mx-10"
                          }, statusInfoFields.map(function (info, i) {
                                return React.createElement("div", {
                                            key: i.toString(),
                                            className: "flex flex-row items-center mb-0.5"
                                          }, React.createElement("div", {
                                                className: "text-sm text-jp-gray-900 text-right min-w-20"
                                              }, info.key), React.createElement("div", {
                                                className: "text-[11px] ml-2.5 pl-2.5 border-l border-jp-gray-300\n                    xs:text-xs"
                                              }, info.value));
                              })))), secondsUntilRedirect !== undefined ? React.createElement("div", {
                      className: "mt-10"
                    }, localeString.linkRedirectionText(secondsUntilRedirect)) : null);
  };
  if (props.integrateError) {
    return React.createElement(ErrorOccured$OrcaPaymentPage.make, {});
  }
  var merchantLogo = options.logo;
  var merchantName = options.collectorName;
  var merchantTheme = options.theme;
  var match$8 = options.flow;
  var tmp;
  tmp = match$8 === "PayoutLinkInitiate" ? (
      showStatus ? renderPayoutStatus() : React.createElement(React.Fragment, {}, React.createElement("div", {
                  className: "flex flex-col w-full h-max items-center p-6\n                lg:w-4/10 lg:px-12 lg:py-20 lg:h-screen lg:items-end",
                  style: {
                    backgroundColor: merchantTheme
                  }
                }, React.createElement("div", {
                      className: "flex flex-col text-white w-full min-w-[300px] max-w-[520px]\n                  lg:rounded-md lg:shadow-lg lg:min-w-80 lg:max-w-96 lg:bg-white lg:text-black"
                    }, React.createElement("div", {
                          className: "flex flex-col-reverse justify-end\n                    lg:mx-5 lg:mt-5 lg:flex-row lg:justify-between"
                        }, React.createElement("div", {
                              className: "font-bold text-5xl mt-5 lg:mt-0 lg:text-3xl flex justify-start items-center"
                            }, React.createElement("p", undefined, options.currency + " " + options.amount)), React.createElement("div", {
                              className: "flex self-start h-12 w-auto bg-white rounded-sm"
                            }, React.createElement("img", {
                                  className: "max-h-12 w-auto max-w-21 h-auto",
                                  alt: "O",
                                  src: merchantLogo
                                }))), React.createElement("div", {
                          className: "lg:mx-5"
                        }, React.createElement("div", {
                              className: "self-center text-xl font-semibold"
                            }, localeString.payoutFromText(merchantName)), React.createElement("div", {
                              className: "flex flex-row lg:mt-1"
                            }, React.createElement("div", {
                                  className: "font-semibold text-xs"
                                }, localeString.infoCardRefId), React.createElement("div", {
                                  className: "ml-1 text-xs"
                                }, options.payoutId))), React.createElement("div", {
                          className: "mt-4 px-4 py-1.5 bg-gray-200 text-[13px] rounded-full w-max text-black\n                    lg:w-full lg:rounded-none lg:rounded-b-lg"
                        }, localeString.linkExpiryInfo(options.sessionExpiry)))), renderCollectWidget())
    ) : React.createElement(React.Fragment, {}, React.createElement("div", {
              className: "flex flex-col w-3/10 p-12",
              style: {
                backgroundColor: merchantTheme
              }
            }, React.createElement("div", {
                  className: "flex flex-row"
                }, React.createElement("img", {
                      className: "h-12 w-auto",
                      alt: "O",
                      src: merchantLogo
                    }), React.createElement("div", {
                      className: "ml-4 text-white self-center text-2xl font-bold"
                    }, merchantName))), renderCollectWidget());
  return React.createElement("div", {
              className: "flex flex-col h-screen min-w-[320px] overflow-hidden\n        lg:flex-row"
            }, tmp);
}

var make = PaymentMethodCollectElement;

var $$default = PaymentMethodCollectElement;

export {
  make ,
  $$default as default,
}
/* jotai Not a pure module */
